export default->
  createdAt: ''
  baseURL: ''
  error: ''
  errorTitle: ''
  path: '/'
  dialogWidth: '100%'
  pizzaExtras: '0.00'
  itemTotal: '0.00'
  pizzaCount: ''
  screenWidth: ''
  headerFeaturesTitle: 'Popular'
  headerMywayTitle: 'My Way'
  headerFaqTitle: 'FAQs'
  headerOrderTitle: 'Cart'
  headerCouponTitle: 'Coupons'
  headerCheckoutTitle: 'Checkout'
  buttonCheckoutLabel: 'Checkout'
  buttonSendOrderLabel: 'Order Now'
  forgetLabel: "Don't Forget"
  buttonMenuLabel: 'Menu'
  okLabel: 'Ok'
  subtotal: 'Subtotal'
  discount: 'Discount'
  menuDrawerRestartLabel: 'Start Over'
  faqMessage: 'Generally asked Questions.'
  orderHeader: 'Your Order'
  orderMessage: 'Please add some items to your order.'
  toggleOpen: 'Open Menu'
  toggleClose: 'Close Menu'
  lang: ''
  panels:
    menu: {}
    category: {}
    menuitemgroup: {}
    pizza: {}
    pizzaType: {}
  jumpCategoryId: null
  drawers:
    menu: false
    order: false
    coupon: false
    features: false
    myway: false
  itemId: ''
  time: ''
  map: ''
  orderDateTime: ''
  orderingBranding:
    enabled: true
    brand: 'Online Orders Now'
    url: 'https://www.onlineordersnow.com/'
  order: ''
  tipLevels: ''
  coupons:
    updated: false
    list: ''
    menuCoupons: ''
  couponsCode: ''
  features:
    updated: false
    list: []
  myway:
    updated: false
    list: []
  recommendations:
    dialog: false,
    list: []
  orderMenu:
    Category: ''
    active: ''
    menuLabel: ''
    menuTimes: ''
    uniqueID: ''
  orderMenuDetails: []
  pizzaItem:
    menuItem: ''
  itemDetails:
    itemLabel: ''
    modifierDets: ''
    menuItem: ''
    addons: ''
  ip: ''
  subdomain: ''
  version: false
  noQty: false
  clickFlag: true
  tableNo: ''
  restaurant:
    details: ''
    apply: ''
    logo: ''
    banner: false
    instantWebsite: false
    banneritems: []
    takeoutLocations: ''
    deliveryLocations: ''
    locationDetails: ''
    flags: []
  location: ''
  descFlag: ''
  menuFlag: ''
  editor:
    orderItem: {}
    orderItemNew: {}
    menuItem: {}
    isNew: true
    visible: false
  mobile: ''
  user:
    address: ''
    address_1: ''
    city: ''
    country: ''
    customerId: ''
    email: ''
    existing: ''
    lat: ''
    lon: ''
    name: ''
    phone: ''
    postal: ''
    state: ''
    updated: ''
    shared: false
  showEdit: false
  menu:
    overflowHidden: false
  stateTime:
    started: new Date().getTime()
    lastActive: ''
    expiration:
      ms: 30 * 60 * 1000
      mins: 30
      time: ''
    warning:
      ms: 5 * 60 * 1000
      mins: 5
      time: ''
  flags: []
  userStart: false
